import React, { useState, useEffect, useRef } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import styles from "./Navbar.module.css";
import logo from "../assets/images/logo/1.png";
import { SECTIONS } from "../data/servicesSections";

const NAV_LINKS = [
  { label: "HOME", path: "/" },
  { label: "ABOUT US", path: "/about-us" },
  // { label: "Software", path: "/software" },
  { label: "SERVICES", path: "/services", dropdown: true },
  { label: "IT TRAINING", path: "/training" },
  { label: "CONTACT US", path: "/contact-us" },

];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const { pathname } = useLocation();
  const servicesRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close services dropdown on outside click
  useEffect(() => {
    const onClickOutside = (e) => {
      if (servicesRef.current && !servicesRef.current.contains(e.target)) {
        setServicesOpen(false);
      }
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMenuOpen(false);
    setMobileServicesOpen(false);
  }, [pathname]);

  return (
    <header className={`${styles.header} ${scrolled ? styles.scrolled : ""}`}>
      <nav className={styles.nav}>
        {/* Logo */}
        <Link to="/" className={styles.logo}>
          <img src={logo} alt="MetaWave Logo" className={styles.logoImg} />
        </Link>
        
        {/* Desktop Links */}
        <ul className={styles.desktopLinks}>
          {NAV_LINKS.map(({ label, path, dropdown }) =>
            dropdown ? (
              <li
                key={path}
                className={styles.dropdownWrapper}
                ref={servicesRef}
                onMouseEnter={() => setServicesOpen(true)}
                onMouseLeave={() => setServicesOpen(false)}
              >
                <div className={styles.dropdownTrigger}>
                  <NavLink
                    to={path}
                    onClick={() => setServicesOpen((o) => !o)}
                    className={({ isActive }) =>
                      `${styles.navLink} ${styles.dropdownNavLink} ${isActive ? styles.navLinkActive : ""}`
                    }
                  >
                    {label}
                  </NavLink>
                  <button
                    type="button"
                    className={`${styles.dropdownArrow} ${servicesOpen ? styles.dropdownArrowOpen : ""}`}
                    onClick={() => setServicesOpen((o) => !o)}
                    aria-label="Toggle services menu"
                    aria-expanded={servicesOpen}
                  >
                    &#9662;
                  </button>
                </div>
                {servicesOpen && (
                  <div className={styles.dropdownMenu}>
                    <ul className={styles.dropdownList}>
                      {SECTIONS.map((s) => (
                        <li key={s.n}>
                          <Link
                            to="/services"
                            state={{ section: s.n, scroll: true }}
                            className={styles.dropdownItem}
                            onClick={() => setServicesOpen(false)}
                          >
                            {s.t}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>
            ) : (
              <li key={path}>
                <NavLink
                  to={path}
                  end={path === "/"}
                  className={({ isActive }) =>
                    `${styles.navLink} ${isActive ? styles.navLinkActive : ""}`
                  }
                >
                  {label}
                </NavLink>
              </li>
            )
          )}
        </ul>

        {/* Desktop CTA */}
        {/* <Link to="/contact" className={styles.ctaBtn}>
          Contact Us
        </Link> */}

        {/* Mobile Hamburger */}
        <button
          className={`${styles.hamburger} ${menuOpen ? styles.hamburgerOpen : ""}`}
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`${styles.mobileMenu} ${menuOpen ? styles.mobileMenuOpen : ""}`}
      >
        <ul>
          {NAV_LINKS.map(({ label, path, dropdown }) =>
            dropdown ? (
              <li key={path}>
                <div className={styles.mobileDropdownTrigger}>
                  <NavLink
                    to={path}
                    onClick={() => setMobileServicesOpen((o) => !o)}
                    className={({ isActive }) =>
                      `${styles.mobileLink} ${isActive ? styles.mobileLinkActive : ""}`
                    }
                  >
                    {label}
                  </NavLink>
                  <button
                    type="button"
                    className={`${styles.dropdownArrow} ${mobileServicesOpen ? styles.dropdownArrowOpen : ""}`}
                    onClick={() => setMobileServicesOpen((o) => !o)}
                    aria-label="Toggle services menu"
                    aria-expanded={mobileServicesOpen}
                  >
                    &#9662;
                  </button>
                </div>
                {mobileServicesOpen && (
                  <ul className={styles.mobileDropdownList}>
                    {SECTIONS.map((s) => (
                      <li key={s.n}>
                        <Link
                          to="/services"
                          state={{ section: s.n, scroll: true }}
                          className={styles.mobileDropdownItem}
                          onClick={() => setMenuOpen(false)}
                        >
                          {s.t}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ) : (
              <li key={path}>
                <NavLink
                  to={path}
                  end={path === "/"}
                  className={({ isActive }) =>
                    `${styles.mobileLink} ${isActive ? styles.mobileLinkActive : ""}`
                  }
                >
                  {label}
                </NavLink>
              </li>
            )
          )}
          <li>
            <Link to="/contact" className={styles.mobileCta}>
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
    </header>
  );
}
